import React, { memo } from "react";

const TextArea = ({
  field,
  onChangeText,
  inputValue,
  inputError,
  showErrors,
  removeErrors,
}: {
  field: any;
  onChangeText?: (
    e: React.FocusEvent<HTMLTextAreaElement>,
    fieldType: string
  ) => void;
  inputValue: string;
  inputError: any;
  showErrors: any;
  removeErrors: (id: string) => void;
}) => {
  return (
    <>
      <textarea
        id={field?.id ?? ""}
        value={inputValue}
        onChange={(e: React.FocusEvent<HTMLTextAreaElement>) => {
          removeErrors(field?.id);
          onChangeText?.(e, "INPUT");
        }}
        className={field?.className ?? ""}
        style={{ ...(field?.style ?? {}) }}
        cols={field?.cols}
        rows={field?.rows}
        placeholder={field?.placeholder ?? "Type your Message"}
      ></textarea>
      {showErrors && (
        <label
          style={{
            color: "#F04438",
            fontSize: "12px",
            ...field.errorMessageStyle,
          }}
        >
          {inputError}
        </label>
      )}
    </>
  );
};

export default memo(TextArea);
